module.exports = __webpack_public_path__ + "assets/media/evening.19479682.mp3";